import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import { createGtag } from "vue-gtag"
import { initAdsConversions } from "./utils/adsConversions"

const app = createApp(App)

// Keep the educational links enabled by default. Deployments that only want
// the editing experience can hide every API link at build time.
app.config.globalProperties.$showApiLinks = process.env.VUE_APP_SHOW_API_LINKS !== 'false'

const tagId = process.env.VUE_APP_GA_ID
if (tagId) {
  app.use(createGtag({
    tagId,
    pageTracker: {
      router
    }
  }))
}

async function start() {
  await store.dispatch('loadApiStatus')
  initAdsConversions({
    router,
    demoMode: store.state.apiStatus.demo_mode
  })
  app.use(store).use(router).mount('#app')
}

start()
